import { FlexRow } from '@/components/common/Flex';
import { hoverStyleProps } from '@/components/common/styleHelpers';
import { Text } from '@/components/common/Typography';
import { useTracking } from '@/services/analytics/useTracking';
import { MouseEventHandler } from 'react';
import { TrackClickEventProps } from '../Button';

interface LeftNavNotificationProps extends TrackClickEventProps {
    text: string;
    icon: React.ReactNode;
    onClick: VoidFunction;
}

export const LEFT_NAV_ACTION_BUTTON_WIDTH = '160px';

const LeftNavActionButton = ({
    text,
    icon,
    onClick,
    onClickEvent,
    onClickEventParams,
}: LeftNavNotificationProps) => {
    const { track } = useTracking();

    const handleClick: MouseEventHandler<HTMLDivElement> = () => {
        if (onClickEvent) {
            track(onClickEvent, onClickEventParams);
        }

        onClick();
    };

    return (
        <FlexRow
            borderRadius="md"
            border="1px solid"
            borderColor="gray.200"
            p={3}
            onClick={handleClick}
            cursor="pointer"
            bg="white"
            zIndex={3}
            {...hoverStyleProps({ bg: 'gray.100' })}
        >
            <FlexRow
                w={LEFT_NAV_ACTION_BUTTON_WIDTH}
                align="center"
                justify="space-between"
            >
                <Text fontSize="sm" fontWeight="medium" color="gray.700">
                    {text}
                </Text>
                {icon}
            </FlexRow>
        </FlexRow>
    );
};

export default LeftNavActionButton;
